// Mirror of apps/api/src/api/component/banking/analytics/banking-analytics.constants.ts.
// Keep BANKING_EVENTS and OFFER_SOURCES values byte-identical with the server.
// Drift is caught at code-review time (both files small, touched together
// when names change).

export const BANKING_EVENTS = {
  OfferViewed: 'Banking Offer Viewed',
  OfferClicked: 'Banking Offer Clicked',
  OfferDismissed: 'Banking Offer Dismissed',
  ApplicationOpened: 'Banking Application Opened',
  ApplicationInProgress: 'Banking Application In Progress',
  ApplicationPendingReview: 'Banking Application Pending Review',
  ApplicationApproved: 'Banking Application Approved',
  ApplicationDenied: 'Banking Application Denied',
  ApplicationCanceled: 'Banking Application Canceled',
  PlaidConnected: 'Banking Plaid Connected',
  AccountUse: 'Banking Account Use',
} as const

export type BankingEventName =
  (typeof BANKING_EVENTS)[keyof typeof BANKING_EVENTS]

export const OFFER_SOURCES = {
  OnboardingBankingIntro: 'onboarding_banking_intro',
  GettingStartedChecklist: 'getting_started_checklist',
  SignupBankCompatibilityModal: 'signup_bank_compatibility_modal',
  OnboardingCantFindBankModal: 'onboarding_cant_find_bank_modal',
  OnboardingDashboardBankingTab: 'onboarding_dashboard_banking_tab',
  DashboardBankingTab: 'dashboard_banking_tab',
  BankingPlaidConnectReminderModal: 'banking_plaid_connect_reminder_modal',
} as const

export type OfferSourceValue =
  (typeof OFFER_SOURCES)[keyof typeof OFFER_SOURCES]

export const BANKING_COHORT_ALPHA = 'alpha'
